<div class="add-panel-container">
    <clare-controller-input
        noscroll="true"
        (onControllerUpdate)="onControllerUpdate($event)"
        [isReadOnly]="isReadOnly"
        [isInsideWizard]="true"
        [claresystem]="existingProject?.claresystem"
    ></clare-controller-input>
</div>
